import { Component, HostListener, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExamRecommendationPopupComponent } from '../../components/exam-recommendation-popup/exam-recommendation-popup';
import { ExamSessionService } from '../../services/exam-session.service';

@Component({
  selector: 'app-exam-recommendation',
  imports: [ExamRecommendationPopupComponent],
  templateUrl: './exam-recommendation.html',
  styleUrl: './exam-recommendation.css',
})
export class ExamRecommendationComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly examSessionService = inject(ExamSessionService);

  protected closeRecommendationPopup(): void {
    void this.router.navigate(['/test-series']);
  }

  protected async enterFullScreen(): Promise<void> {
    const rootElement = document.documentElement;

    if (rootElement.requestFullscreen) {
      try {
        await rootElement.requestFullscreen();
      } catch {
        // Continue to the exam even if fullscreen is rejected by the browser.
      }
    }

    this.navigateToNextStep();
  }

  @HostListener('document:keydown', ['$event'])
  protected async onDocumentKeydown(event: KeyboardEvent): Promise<void> {
    if (event.key !== 'F11') {
      return;
    }

    event.preventDefault();
    await this.enterFullScreen();
  }

  private navigateToNextStep(): void {
    const testId = this.route.snapshot.paramMap.get('id');

    if (!testId) {
      void this.router.navigate(['/test-series']);
      return;
    }

    const isResume = this.examSessionService.activeExamMeta()?.isResume;
    if (isResume) {
      void this.router.navigate(['/test-series', testId, 'question-paper'], { replaceUrl: true });
    } else {
      void this.router.navigate(['/test-series', testId, 'instructions'], { replaceUrl: true });
    }
  }
}
